module.exports = __webpack_public_path__ + "static/media/dj.880bdfa1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/dj.svg
// module id = 2076
// module chunks = 0